<template>
  <div class="pricing-block">
    <div class="title-block">
      <h3>Des prix transparents et dégressifs !</h3>
      <p>
        Faites glisser le curseur pour découvrir nos offres et bénéficier de
        tarifs avantageux.
      </p>
    </div>
    <SliderPricing v-model="state.nbCredits" :pricing="pricing" :default="creditsNeeded" />
    <PreviewBlock :nbCredits="state.nbCredits" :pricing="pricing" @close="emits('close')" />
    <div class="btn-inline">
      <Button class="secondary outline" label="Retour" @click="emits('close')" />
      <Button class="icon primary" label="Étape suivante" icon="bi-arrow-right" :loading="isLoading"
        :disabled="state.nbCredits > 50" @click="emits('next')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref, watch } from "vue";
import SliderPricing, { Pricing } from "../SliderPricing.vue";
import PreviewBlock from "./PreviewBlock.vue";

const emits = defineEmits(["next", "close", "changeCredits"]);

defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
  creditsNeeded: {
    type: Number,
    default: 1,
  },
});

const state = reactive({
  nbCredits: 1,
});

const pricing = ref<Pricing[]>([
  {
    amount: 1,
    gift: 0,
    price: 100,
  },
  {
    amount: 3,
    gift: 1,
    price: 200,
  },
  {
    amount: 5,
    gift: 2,
    price: 300,
  },
  {
    amount: 10,
    gift: 5,
    price: 500,
  }
]);

watch(state, () => {
  emits("changeCredits", state.nbCredits);
});
</script>
